import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar, Button } from 'antd';
import './Header.css';

export default function Header({ loggedInUser, onLogout, unreadCount = 0 }) {
  return (
    <div className="header-container">
      <div className="header-center">
        <Link to="/" className="header-link">首页</Link>
        <Link to="/write" className="header-link">写文章</Link>
        <Link to="/archive" className="header-link">文章归档</Link>
        <Link to="/myposts" className="header-link">我的</Link>
        <Link to="/settings" className="header-link">设置</Link>
      </div>

      <div className="header-right">
        {loggedInUser ? (
          <>
            {loggedInUser?.avatar ? (
              <Avatar src={loggedInUser.avatar} alt={loggedInUser.name} size={36} />
            ) : (
              <Avatar style={{ backgroundColor: '#f56a00' }} size={36}>{(loggedInUser.name || '').slice(0,1)}</Avatar>
            )}

            <div style={{ marginLeft: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ color: '#fff', fontSize: 14 }}>{loggedInUser.name}</span>
              <Button type="default" size="small" onClick={onLogout}>
                登出
              </Button>
            </div>
          </>
        ) : (
          <Link to="/auth" className="header-link">登录</Link>
        )}
      </div>
    </div>
  );
}
